export const SnackBarModel = {
  open: false,
  vertical: "top",
  horizontal: "right",
  severity: "info", // error - warning - info - success
  duration: 3000,
  message: "",
};
